import { ItemKind } from '../../../constants/ItemKind';
export const toFolder = data => {
  return {
    id: data.id,
    name: data.title,
    kind: ItemKind.Folder,
    source: 'drive',
    parentId: data.parents[0].id,
    filesCount: 1,
    createdAt: data.createdDate
  };
};